import { faGlobe } from "@outschool/icons";
import { useTranslation } from "@outschool/localization";
import { useImpressionTracking } from "@outschool/ui-legacy-component-library";
import { useIsTablet } from "@outschool/ui-utils";
import React from "react";

import { HeaderMenuItem } from "../nav/HeaderMenu";
import LocalizationPickerMobile from "./LocalizationPickerMobile";
import LocalizationPickerModal from "./LocalizationPickerModal";

export default function LocalizationPickerHeaderMenuItem() {
  const { t } = useTranslation(
    "client\\components\\localization\\LocalizationPickerHeader"
  );
  const isTablet = useIsTablet();

  const [localizationMenuOpen, setLocalizationMenuOpen] =
    React.useState<boolean>(false);
  const openLocalizationMenu = () => setLocalizationMenuOpen(true);
  const closeLocalizationMenu = () => setLocalizationMenuOpen(false);

  const trackingName = "localization_picker";

  const { trackTouch } = useImpressionTracking({
    trackingLabel: trackingName,
    uniqueId: trackingName,
    sharedProperties: {
      platformView: "mobile"
    }
  });

  const handleClick = () => {
    trackTouch();
    openLocalizationMenu();
  };

  return (
    <>
      <button
        data-test-id="header-localization-picker"
        onClick={handleClick}
        style={{
          padding: "0px",
          boxShadow: "none",
          borderColor: "none",
          borderWidth: "0px",
          backgroundColor: "transparent",
          color: "#gray1",
          fontWeight: "normal",
          cursor: "pointer"
        }}
      >
        <HeaderMenuItem icon={faGlobe}>{t`Language & Region`}</HeaderMenuItem>
      </button>
      {isTablet ? (
        <LocalizationPickerMobile
          open={localizationMenuOpen}
          onClose={closeLocalizationMenu}
          onBack={closeLocalizationMenu}
        />
      ) : (
        <LocalizationPickerModal
          open={localizationMenuOpen}
          onClose={closeLocalizationMenu}
        />
      )}
    </>
  );
}
